import { store } from "@cozumel-reef-maps/web_general/js/store/store.js";
import { 
  renderTablaPagos_Recibidos, 
  renderCalendarPagos, 
  loadPagosByMonth,
  qr_generator,
  payments_config
   } from "@cozumel-reef-maps/web_general/js/ui/general_members.js";


import { makeQR } from "@cozumel-reef-maps/web_general/js/utils/helpers.js";
import { hidde_preloader } from "@cozumel-reef-maps/web_general/js/ui/preloader.js";




var URL_PHP = "https://cozumel-reef-maps.com.mx";








// La función por defecto que el Router llamará automáticamente al entrar a /Dashboard/index
export default function initMembersDashboard(container) {
    


          // ======================================================
          // PRIMER LOAD (al entrar al dashboard)
          // ======================================================

          const today = new Date();

          const calendarState = {
            year: today.getFullYear(),   // año actual
            month: today.getMonth()      // mes actual (0–11)
          };

          loadPagosByMonth(calendarState.year, calendarState.month);



          makeQR(store.URL_PHP+"?reference_id_member="+store.session.user.key_user, "qrcode");


           const canvas = document.getElementById("qrcode");

           canvas.addEventListener("click", function () {
              const enlace = document.createElement("a");
              enlace.download = "qr_referral.png"; // Nombre del archivo
              enlace.href = canvas.toDataURL("image/png");
              enlace.click();
            });





        hidde_preloader();

        ver_arrecifes();



        console.log("APP VERSION:", store.version);

        if (store.session.logged) {
          console.log("Usuario activo:", store.session.user.email);
          console.log("KEY_USER:", store.session.user.key_user);
          console.log("COMISION:", store.session.user.comision);
        }






              


}













function copyReferralLink() {
    const text = document.getElementById("ref-link").innerText;
    navigator.clipboard.writeText(text).then(() => {
        alert("Link copied to clipboard!");
    });
}





const diveSites = [

    {
    name: "Colombia Deep",
    url: "https://cozumel-reef-maps.com.mx/Index/reef/Colombia-Deep",
    depth: "25 to 35 meters",
    diveLevel: "Intermediate to advanced",
    currents: "Moderate",
    coralFormations: "Deep rocky corals and vertical structures"
  },{
    name: "Colombia Regular",
    url: "https://cozumel-reef-maps.com.mx/Index/reef/Colombia-Regular",
    depth: "12 to 25 meters",
    diveLevel: "All levels",
    currents: "Mild to moderate",
    coralFormations: "Coral gardens and rocks with abundant marine life"
  },{
    name: "Palancar Bricks",
    url: "https://cozumel-reef-maps.com.mx/Index/reef/Palancar-Bricks",
    depth: "18 to 28 meters",
    diveLevel: "Intermediate",
    currents: "Moderate",
    coralFormations: "Brick-like corals and coral gardens"
  },{
    name: "Palancar Caves",
    url: "https://cozumel-reef-maps.com.mx/Index/reef/Palancar-Caves",
    depth: "18 to 35 meters",
    diveLevel: "Intermediate to advanced",
    currents: "Moderate",
    coralFormations: "Caves and coral tunnels, sea fans"
  },{
    name: "Palancar Gardens",
    url: "https://cozumel-reef-maps.com.mx/Index/reef/Palancar-Gardens",
    depth: "10 to 20 meters",
    diveLevel: "Beginner to intermediate",
    currents: "Mild",
    coralFormations: "Coral gardens with a variety of hard and soft corals"
  },{
    name: "Dalila-Francesa",
    url: "https://cozumel-reef-maps.com.mx/Index/reef/Dalila-Francesa",
    depth: "12 to 25 meters",
    diveLevel: "Intermediate",
    currents: "Mild",
    coralFormations: "Mixed reefs with hard and soft corals"
  },{
    name: "El Cedral",
    url: "https://cozumel-reef-maps.com.mx/Index/reef/El-Cedral",
    depth: "10 to 20 meters",
    diveLevel: "Beginner to intermediate",
    currents: "Mild",
    coralFormations: "Coral gardens and small rock formations"
  },
  {
    name: "Santa Rosa Wall",
    url: "https://cozumel-reef-maps.com.mx/Index/reef/Santa-Rosa-Wall",
    depth: "15 to 40 meters (wall up to 300 m)",
    diveLevel: "Intermediate to advanced",
    currents: "Moderate to strong, ideal for drift diving",
    coralFormations: "Rocky corals, tubular sponges, sea fans"
  },{
    name: "San Clemente",
    url: "https://cozumel-reef-maps.com.mx/Index/reef/San-Clemente",
    depth: "10 to 32 meters",
    diveLevel: "Beginner",
    currents: "Mild to moderate",
    coralFormations: "Soft corals, tropical fish, and starfish"
  },{
    name: "Yucab",
    url: "https://cozumel-reef-maps.com.mx/Index/reef/Yucab",
    depth: "15 to 30 meters",
    diveLevel: "Intermediate",
    currents: "Moderate",
    coralFormations: "Soft corals, sea fans, and hard corals"
  },{
    name: "Tormentos",
    url: "https://cozumel-reef-maps.com.mx/Index/reef/Tormentos",
    depth: "15 to 35 meters",
    diveLevel: "Intermediate to advanced",
    currents: "Moderate to strong",
    coralFormations: "Hard corals, rocks, and sea fans"
  },{
    name: "Chankanab",
    url: "https://cozumel-reef-maps.com.mx/Index/reef/Chankanab",
    depth: "15 to 30 meters",
    diveLevel: "Intermediate",
    currents: "Mild to moderate",
    coralFormations: "Hard and soft corals, rocks, and coral gardens"
  },{
    name: "C53 Felipe Xicotencatl",
    url: "https://cozumel-reef-maps.com.mx/Index/mobil_joystick/C53-Felipe-Xicotencatl",
    depth: "15 to 30 meters",
    diveLevel: "Intermediate",
    currents: "Mild to moderate",
    coralFormations: "Hard and soft corals, rocks, and coral gardens"
  },{
    name: "Paraíso",
    url: "https://cozumel-reef-maps.com.mx/Index/reef/Paraiso",
    depth: "5 to 15 meters",
    diveLevel: "Beginner",
    currents: "Very mild",
    coralFormations: "Soft corals, tropical fish, and starfish"
  }
  
 
  
  
  
];





  const svg = {
    dive: '<svg class="icon-flag" width="18" height="18" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><rect x="0" y="0" width="24" height="24" fill="#ff0000"/><polygon points="0,24 24,0 27,2 2,28" fill="#ffffff"/></svg>'
  };





function ver_arrecifes() {
  document.getElementById("reefs_list").style.display = "block";
  const container = document.getElementById("dive_container_reefs");


   container.innerHTML += `
      <div class="col-lg-4 col-md-6"  style="margin-bottom: 40px;">
          <a style="color:#419ace;" href="${URL_PHP}/Index/cozumel_map">
              <div class="snippets">
                  <h5>Cozumel Full Map</h5>

              <img src="${URL_PHP}/Views/Default/img/cozumel_dive_sites_map.jpg"/ style="width:90%; margin:0 auto;">
                 
                  <span>🪸</span>
              </div>
          </a>
      </div>
    `;



    container.innerHTML += `
      <div class="col-lg-4 col-md-6"  style="margin-bottom: 40px;">
          <a style="color:#419ace;" href="${URL_PHP}/Index/mobil_joystick/C53-Felipe-Xicotencatl">
              <div class="snippets">
                   <h5>${svg.dive} C53 Felipe Xicotencatl</h5>

              <img src="${URL_PHP}/Views/Default/img/felipe_xicotencatl.jpg"/ style="width:90%; margin:0 auto;">
                 
                  <span>🪸</span>
              </div>
          </a>
      </div>
    `;


  diveSites.forEach(site => {
    container.innerHTML += `
      <div class="col-lg-4 col-md-6"  style="margin-bottom: 40px;">
          <a style="color:#419ace;" href="${site.url}">
              <div class="snippets">
                  <h5>${svg.dive} ${site.name}</h5>
                  <ul style="list-style:circle; text-align:left;">
                      <li><strong>Depth:</strong> ${site.depth}</li>
                      <li><strong>Dive level:</strong> ${site.diveLevel}</li>
                      <li><strong>Currents:</strong> ${site.currents}</li>
                      <li><strong>Coral formations:</strong> ${site.coralFormations}</li>
                  </ul>
                  <span>🪸</span>
              </div>
          </a>
      </div>
    `;
  });




}






/* =========================================
   YOUTUBE VIDEOS
========================================= */
const youtubeVideos = {
    referral: "https://www.youtube.com/embed/BFdttG0SeDI",      // Video del QR / Referidos
    payments: "https://www.youtube.com/embed/a7JDuttaC34",      // ← Cambia este ID
    // payments2: "https://www.youtube.com/embed/YYYYYYYYYYY"  // ← Si quieres un 3er video
};

/* =========================================
   OPEN POPUP (acepta el nombre del video)
========================================= */
function openYoutubePopup(videoKey) {
    const popup = document.getElementById("youtubePopup");
    const iframe = document.getElementById("youtubeIframe");

    const videoUrl = youtubeVideos[videoKey];

    if (!videoUrl) {
        console.error("Video no encontrado:", videoKey);
        return;
    }

    // Cargamos el video solo cuando se abre el popup
    iframe.src = videoUrl + "?autoplay=1";
    popup.style.display = "flex";
    document.body.style.overflow = "hidden";
}

/* =========================================
   CLOSE POPUP
========================================= */
function closeYoutubePopup(event) {
    // Si hicieron click dentro del contenido del video, no cerrar
    if (event && event.target && event.target.closest(".youtube-popup-content")) {
        return;
    }

    const popup = document.getElementById("youtubePopup");
    const iframe = document.getElementById("youtubeIframe");

    // Detener el video completamente
    iframe.src = "";
    popup.style.display = "none";
    document.body.style.overflow = "";
}

/* =========================================
   ESC KEY
========================================= */
document.addEventListener("keydown", function(event) {
    if (event.key === "Escape") {
        closeYoutubePopup();
    }
});






window.copyReferralLink = copyReferralLink;
window.qr_generator = qr_generator;
window.payments_config = payments_config;
window.openYoutubePopup = openYoutubePopup;
window.closeYoutubePopup = closeYoutubePopup;